import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { SharedDataService, Staff } from 'orv-ui-base-lib';
import { Observer } from 'rxjs';
import { of } from 'rxjs/internal/observable/of';
import { Observable } from 'rxjs/Observable';

import { AclService } from '../data/acl.service';
import { AuthService } from './auth.service';

@Injectable()
export class AuthenticationGuardService implements CanActivate, CanActivateChild {

	loggedUser: Staff;

	constructor(private logger: NGXLogger, private sharedDataService: SharedDataService,
		private router: Router,
		private authService: AuthService,
		private aclService: AclService) {
		this.sharedDataService.currentLoggedUser.subscribe(loggedUser => { this.loggedUser = loggedUser; });
	}


	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		if (this.loggedUser) {
			if (this.checkAclFeatures(route)) {
				return of(true);
			} else {
				return of(false);
			}
		} else {
			if (this.authService.hasCookie()) {
				return Observable.create((observer: Observer<any>) => {
					this.authService.getLoggedUser().subscribe(() => {
						observer.next(true);
						observer.complete();
					}, (err: any) => {
						this.logger.log(err);
						observer.next(false);
						observer.complete();
					});
				});
			} else {
				this.router.navigate(['login'], {});
				return of(false);
			}
		}
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		if (this.checkAclFeatures(route)) {
			return of(true);
		} else {
			return of(false);
		}
	}

	checkAclFeatures(route: ActivatedRouteSnapshot) {
		const aclFeatures = route.data.aclFeatures;
		const perm = this.aclService.hasPermission(aclFeatures) && this.aclService.hasPermissionInSection(route.data.section);
		if (perm) {
			return true;
		} else {
			this.router.navigateByUrl('/unauthorized');
		}
	}
}
